import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { useAuthStatus, getTodayDateString, useToken } from '../../../utils'
import { updateOfferVisitStatus, fetchContractById } from '../../../services/api'
// import { useOfferList, useLikedOffers, useUpdateLikedOffers } from '../../../hooks/offer'
import { useOfferList } from '../../../hooks/offer'
// import { useLikedOffers, useUpdateLikedOffers } from '../../../hooks/offer'
import { Link, useLocation } from 'react-router-dom'
import styles from './OfferManagement.module.scss'
import { ArrowsRightLeftIcon } from '@heroicons/react/24/solid'
import HistoryModal from './HistoryModal'
import { ChevronRightIcon } from '@heroicons/react/24/solid'
import { useNavigate } from 'react-router-dom'
import OfferItem from './components/OfferItem'
import SubTabMenu from './components/SubTabMenu'

const renewIsVisited = async (offerId) => {
	try {
		await updateOfferVisitStatus(offerId)
	} catch {
		console.error('isVisited 갱신에 실패하였습니다.')
	}
}

const TAB_MENU = [
	{ value: 'received', label: '받은 제안' },
	{ value: 'sent', label: '보낸 제안' },
	{ value: 'past', label: '지난 내역' },
]

const EMPTY_STATE_CONFIG = {
	received: {
		title: '받은 제안이 아직 없어요.',
	},
	sent: {
		title: '보낸 제안이 아직 없어요.',
	},
	past: {
		title: '지난 내역이 아직 없어요.',
	},
}

export const OfferManagement = ({ ...props }) => {
	const [auth, onChangeAuthStatus] = useAuthStatus()
	const location = useLocation()

	const token = useToken()
	// react-query에서 상태 관리하므로 로컬 상태 제거
	// location.state.defaultTab 우선, 없으면 sessionStorage, 없으면 기본값 'received'
	const [selectedTab, setSelectedTab] = useState(() => {
		if (location.state?.defaultTab) {
			return location.state.defaultTab
		}
		return sessionStorage.getItem('offer-selected-tab') || 'received'
	})
	const [subSelectedTab, setSubSelectedTab] = useState('all')
	const [sortOrder, setSortOrder] = useState(() => {
		return sessionStorage.getItem('offer-sort-order') || 'newest'
	})

	// location.state가 변경될 때 탭 업데이트 (뒤로 가기 등)
	useEffect(() => {
		if (location.state?.defaultTab) {
			setSelectedTab(location.state.defaultTab)
		}
	}, [location.state])

	// 페이지네이션 관련 상태
	const [currentPage, setCurrentPage] = useState(1)
	const [itemsPerPage] = useState(5)
	const [pageGroupSize] = useState(5)
	const [currentPageGroupStart, setCurrentPageGroupStart] = useState(1)
	const [pageNumbers, setPageNumbers] = useState([])

	// 각 서브 탭별 항목 개수 상태 (useMemo로 계산)

	const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false)
	const [historyModalData, setHistoryModalData] = useState(null)
	const [isHistoryModalDragging, setIsHistoryModalDragging] = useState(false)
	const [historyModalDragOffset, setHistoryModalDragOffset] = useState({ x: 0, y: 0 })
	const [historyModalPosition, setHistoryModalPosition] = useState({ x: 0, y: 0 })
	const [historyModalHasBeenDragged, setHistoryModalHasBeenDragged] = useState(false)
	const historyModalRef = useRef(null)
	const [caddiePendingContracts, setCaddiePendingContracts] = useState([])
	const navigate = useNavigate()

	// react-query 훅으로 제안 목록 조회 (useMemo보다 먼저 호출)
	const {
		data: offers = [],
		isLoading,
		isError,
		error,
		refetch,
	} = useOfferList(token, !!auth.user?.id)

	// const { data: likedOffersData } = useLikedOffers(auth?.user?.id)
	// const updateLikedOffersMutation = useUpdateLikedOffers()

	// 관심 제안 ID들을 Set으로 변환
	// const likedContractIds = useMemo(() => {
	// 	if (
	// 		!likedOffersData?.likedContractIds ||
	// 		!Array.isArray(likedOffersData.likedContractIds)
	// 	) {
	// 		return new Set()
	// 	}
	// 	return new Set(likedOffersData.likedContractIds)
	// }, [likedOffersData])

	// 관심 제안 토글 함수
	// const toggleLikedOffer = useCallback(
	// 	(offerId) => {
	// 		const newLikedIds = new Set(likedContractIds)
	// 		if (newLikedIds.has(offerId)) {
	// 			newLikedIds.delete(offerId)
	// 		} else {
	// 			newLikedIds.add(offerId)
	// 		}

	// 		// 서버에 업데이트
	// 		updateLikedOffersMutation.mutate({
	// 			userId: auth.user.id,
	// 			likedContractIds: Array.from(newLikedIds),
	// 		})
	// 	},
	// 	[likedContractIds],
	// )
	// const likedContractIds = new Set() // 임시 빈 Set

	// console.log('offers:', offers)

	// 받은 제안 필터링 (useMemo로 계산)
	const recievedFiltered = useMemo(() => {
		if (!offers) {
			return []
		}

		// 거절, 취소, 만료된 제안, 계약 제안된 제안은 제외
		return offers.filter(
			(item) =>
				item &&
				item.target_user_id === auth.user.id &&
				item.offer_status !== 'REJECTED' &&
				item.offer_status !== 'REJECT' &&
				item.offer_status !== 'CANCEL' &&
				item.offer_status !== 'OUTDATED' &&
				item.offer_status !== 'CONTRACT_PROPOSED',
		)
	}, [offers, auth.user.id])

	// 보낸 제안 필터링 (useMemo로 계산)
	const sentFiltered = useMemo(() => {
		if (!offers) {
			return []
		}

		return offers.filter(
			(item) =>
				item &&
				item.user_id === auth.user.id &&
				item.offer_status !== 'REJECTED' &&
				item.offer_status !== 'REJECT' &&
				item.offer_status !== 'CANCEL' &&
				item.offer_status !== 'OUTDATED' &&
				item.offer_status !== 'CONTRACT_PROPOSED',
		)
	}, [offers, auth.user.id])

	// 지난 내역 필터링 (useMemo로 계산)
	const pastFiltered = useMemo(() => {
		if (!offers) {
			return []
		}

		// 거절, 취소, 만료된 제안, 계약 제안된 제안 모두 포함
		return offers.filter(
			(item) =>
				item &&
				(item.user_id === auth.user.id || item.target_user_id === auth.user.id) &&
				item.offer_status !== 'PRE' &&
				item.offer_status !== 'PROCEEDING',
		)
	}, [offers, auth.user.id])

	// 필터링된 계약 리스트를 useMemo로 계산
	const filteredContracts = useMemo(() => {
		if (selectedTab === 'received') {
			if (subSelectedTab === 'all') {
				return recievedFiltered
			} else if (subSelectedTab === 'pending') {
				return recievedFiltered.filter((item) => item.offer_status === 'PRE')
			} else if (subSelectedTab === 'negotiating') {
				return recievedFiltered.filter((item) => item.offer_status === 'PROCEEDING')
				// } else if (subSelectedTab === 'liked') {
				// 	return recievedFiltered.filter((item) => likedContractIds.has(item.offer_id))
				// }
			}
		} else if (selectedTab === 'sent') {
			if (subSelectedTab === 'all') {
				return sentFiltered
			} else if (subSelectedTab === 'pending') {
				return sentFiltered.filter((item) => item.offer_status === 'PRE')
			} else if (subSelectedTab === 'negotiating') {
				return sentFiltered.filter((item) => item.offer_status === 'PROCEEDING')
				// } else if (subSelectedTab === 'liked') {
				// 	return sentFiltered.filter((item) => likedContractIds.has(item.offer_id))
				// }
			}
		} else if (selectedTab === 'past') {
			return pastFiltered
		}
		return []
	}, [selectedTab, subSelectedTab, recievedFiltered, sentFiltered, pastFiltered])

	// 메인 탭 변경 핸들러 (이전과 동일)
	const handleTabChange = (tab) => {
		setSelectedTab(tab)
		setSubSelectedTab('all')
		setCurrentPage(1)
		setCurrentPageGroupStart(1)
		sessionStorage.setItem('offer-selected-tab', tab)
	}

	// 서브 탭 변경 핸들러 (이전과 동일)
	const handleSubTabChange = (subTab) => {
		setSubSelectedTab(subTab)
		setCurrentPage(1)
		setCurrentPageGroupStart(1)
	}

	// 정렬 변경 핸들러
	const handleSortChange = () => {
		const newSortOrder = sortOrder === 'newest' ? 'oldest' : 'newest'
		setSortOrder(newSortOrder)
		sessionStorage.setItem('offer-sort-order', newSortOrder)
	}

	// 히스토리 모달 관련 핸들링 함수들
	const handleHistoryModalMouseDown = useCallback((e) => {
		if (historyModalRef.current) {
			const rect = historyModalRef.current.getBoundingClientRect()
			setHistoryModalDragOffset({
				x: e.clientX - rect.left,
				y: e.clientY - rect.top,
			})
			setIsHistoryModalDragging(true)
		}
	}, [])

	const handleHistoryModalMouseMove = useCallback(
		(e) => {
			if (isHistoryModalDragging && historyModalRef.current) {
				const newX = e.clientX - historyModalDragOffset.x
				const newY = e.clientY - historyModalDragOffset.y

				// 화면 경계 체크
				const maxX = window.innerWidth - historyModalRef.current.offsetWidth
				const maxY = window.innerHeight - historyModalRef.current.offsetHeight

				const clampedX = Math.max(0, Math.min(newX, maxX))
				const clampedY = Math.max(0, Math.min(newY, maxY))

				historyModalRef.current.style.transform = `translate(${clampedX}px, ${clampedY}px)`

				// 위치 업데이트
				setHistoryModalPosition({ x: clampedX, y: clampedY })
				setHistoryModalHasBeenDragged(true)
			}
		},
		[isHistoryModalDragging, historyModalDragOffset],
	)

	const handleHistoryModalMouseUp = useCallback(() => {
		setIsHistoryModalDragging(false)
	}, [])

	// 히스토리 모달 관련 useEffect들
	useEffect(() => {
		if (isHistoryModalDragging) {
			document.addEventListener('mousemove', handleHistoryModalMouseMove)
			document.addEventListener('mouseup', handleHistoryModalMouseUp)
			return () => {
				document.removeEventListener('mousemove', handleHistoryModalMouseMove)
				document.removeEventListener('mouseup', handleHistoryModalMouseUp)
			}
		}
	}, [isHistoryModalDragging, handleHistoryModalMouseMove, handleHistoryModalMouseUp])

	// 히스토리 모달이 열릴 때 위치 설정
	useEffect(() => {
		if (isHistoryModalOpen && historyModalRef.current) {
			let targetX, targetY

			if (historyModalHasBeenDragged) {
				// 이전에 드래그한 위치가 있으면 그 위치 사용
				targetX = historyModalPosition.x
				targetY = historyModalPosition.y
			} else {
				// 처음 열리는 경우 왼쪽 30%, 위쪽 50% 위치
				const modalWidth = 400
				const modalHeight = 500
				targetX = window.innerWidth * 0.3 - modalWidth / 2
				targetY = window.innerHeight * 0.5 - modalHeight / 2
			}

			historyModalRef.current.style.transform = `translate(${targetX}px, ${targetY}px)`
		}
	}, [isHistoryModalOpen, historyModalHasBeenDragged, historyModalPosition])

	// ESC 키로 히스토리 모달 닫기
	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === 'Escape' && isHistoryModalOpen) {
				setIsHistoryModalOpen(false)
			}
		}

		document.addEventListener('keydown', handleKeyDown)
		return () => {
			document.removeEventListener('keydown', handleKeyDown)
		}
	}, [isHistoryModalOpen])

	const handleOfferClick = (item) => {
		console.log('item:', item)
		// navigate(`/offers/${item.offer.id}`)
	}

	// 페이지네이션 로직 (이전과 동일)
	// 정렬 적용된 리스트
	const sortedContracts = useMemo(() => {
		const list = Array.isArray(filteredContracts) ? [...filteredContracts] : []
		list.sort((a, b) => {
			const dateA = new Date(a?.created_at)
			const dateB = new Date(b?.created_at)
			return sortOrder === 'newest' ? dateB - dateA : dateA - dateB
		})
		return list
	}, [filteredContracts, sortOrder])

	const indexOfLastItem = currentPage * itemsPerPage
	const indexOfFirstItem = indexOfLastItem - itemsPerPage
	const currentItems = (sortedContracts || []).slice(indexOfFirstItem, indexOfLastItem)

	const totalPages = Math.ceil((filteredContracts || []).length / itemsPerPage)

	const paginate = (pageNumber) => {
		setCurrentPage(pageNumber)
		if (
			pageNumber < currentPageGroupStart ||
			pageNumber >= currentPageGroupStart + pageGroupSize
		) {
			setCurrentPageGroupStart(
				Math.floor((pageNumber - 1) / pageGroupSize) * pageGroupSize + 1,
			)
		}
	}
	const goToNextPageGroup = () => {
		const nextGroupStart = currentPageGroupStart + pageGroupSize
		if (nextGroupStart <= totalPages) {
			setCurrentPageGroupStart(nextGroupStart)
			setCurrentPage(nextGroupStart)
		}
	}
	const goToPrevPageGroup = () => {
		const prevGroupStart = currentPageGroupStart - pageGroupSize
		if (prevGroupStart >= 1) {
			setCurrentPageGroupStart(prevGroupStart)
			setCurrentPage(prevGroupStart + pageGroupSize - 1) // 이전 그룹의 마지막 페이지로 이동
		} else {
			setCurrentPageGroupStart(1)
			setCurrentPage(1)
		}
	}
	useEffect(() => {
		let pages = []
		console.log('currentPageGroupStart:', currentPageGroupStart)
		console.log('pageGroupSize:', pageGroupSize)
		console.log('totalPages:', totalPages)
		const currentGroupEnd = Math.min(currentPageGroupStart + pageGroupSize - 1, totalPages)
		for (let i = currentPageGroupStart; i <= currentGroupEnd; i++) {
			pages.push(i)
		}
		setPageNumbers(pages)
		console.log('pageNumbers:', pages)
	}, [currentPageGroupStart, pageGroupSize, totalPages])
	// const pageNumbers = []
	// const currentGroupEnd = Math.min(currentPageGroupStart + pageGroupSize - 1, totalPages)
	// for (let i = currentPageGroupStart; i <= currentGroupEnd; i++) {
	// 	pageNumbers.push(i)
	// }
	// useEffect(() => {
	// 	console.log('pageNumbers:', pageNumbers)
	// }, [pageNumbers])

	if (isLoading) {
		return (
			<div className={styles.suggestManagementDefaultContainer}>
				제안을 불러오는 중입니다...
			</div>
		)
	}

	if (isError) {
		return (
			<div className={styles.suggestManagementDefaultContainer}>
				오류: {error?.message || error?.toString() || '알 수 없는 오류가 발생했습니다.'}
			</div>
		)
	}

	return (
		<div className={styles.suggestManagementDefaultContainer}>
			{isHistoryModalOpen && (
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						zIndex: 999,
					}}
					onClick={() => setIsHistoryModalOpen(false)}>
					<div
						ref={historyModalRef}
						style={{
							width: 'fit-content',
							height: 'fit-content',
							position: 'fixed',
							top: 0,
							left: 0,
							zIndex: 1000,
							cursor: isHistoryModalDragging ? 'grabbing' : 'grab',
						}}
						onMouseDown={handleHistoryModalMouseDown}
						onClick={(e) => e.stopPropagation()}>
						<HistoryModal
							onClose={() => setIsHistoryModalOpen(false)}
							offerHistory={historyModalData}
						/>
					</div>
				</div>
			)}
			<div className={styles.title}>
				<div>제안 관리</div>
				<div>관심있는 상대에게 제안을 보내고 받아보세요!</div>
			</div>
			<div className={styles.userSelectType}>
				{TAB_MENU.map((tab) => (
					<div
						key={tab.value}
						className={selectedTab === tab.value ? styles.active : ''}
						onClick={() => handleTabChange(tab.value)}>
						{tab.label}
					</div>
				))}
			</div>

			{/* 정렬 버튼 (PreContractManagementDefaultView와 동일 위치/동작) */}
			<div style={{ display: 'flex', justifyContent: 'flex-end', margin: '8px 0 12px 0' }}>
				<button
					onClick={handleSortChange}
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: '6px',
						padding: '6px 10px',
						borderRadius: '6px',
						border: 'none',
						background: 'transparent',
						cursor: 'pointer',
						fontSize: '12px',
						fontFamily: 'Pretendard-Regular',
						color: '#8D8D8D',
					}}>
					<svg
						width="12"
						height="11"
						viewBox="0 0 12 11"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M0.3125 0.625C0.3125 0.383375 0.508375 0.1875 0.75 0.1875H9.0625C9.30412 0.1875 9.5 0.383375 9.5 0.625C9.5 0.866625 9.30412 1.0625 9.0625 1.0625H0.75C0.508375 1.0625 0.3125 0.866625 0.3125 0.625ZM8.75314 2.94064C8.924 2.76979 9.201 2.76979 9.37186 2.94064L11.5594 5.12814C11.7302 5.299 11.7302 5.576 11.5594 5.74686C11.3885 5.91771 11.1115 5.91771 10.9406 5.74686L9.5 4.30622L9.5 10.25C9.5 10.4916 9.30412 10.6875 9.0625 10.6875C8.82088 10.6875 8.625 10.4916 8.625 10.25L8.625 4.30622L7.18436 5.74686C7.0135 5.91771 6.7365 5.91771 6.56564 5.74686C6.39479 5.576 6.39479 5.29899 6.56564 5.12814L8.75314 2.94064ZM0.3125 3.25C0.3125 3.00838 0.508375 2.8125 0.75 2.8125H6.4375C6.67912 2.8125 6.875 3.00838 6.875 3.25C6.875 3.49162 6.67912 3.6875 6.4375 3.6875H0.75C0.508375 3.6875 0.3125 3.49162 0.3125 3.25ZM0.3125 5.875C0.3125 5.63338 0.508375 5.4375 0.75 5.4375H3.8125C4.05412 5.4375 4.25 5.63338 4.25 5.875C4.25 6.11662 4.05412 6.3125 3.8125 6.3125H0.75C0.508375 6.3125 0.3125 6.11662 0.3125 5.875Z"
							fill="#A0A0A0"
						/>
					</svg>
					{sortOrder === 'newest' ? '최신순' : '오래된순'}
				</button>
			</div>

			<div className={styles.contractList}>
				<SubTabMenu
					categoryClassName={styles.contractItemCategory}
					activeClassName={styles.active}
					tabType={selectedTab}
					subSelectedTab={subSelectedTab}
					onSubTabChange={handleSubTabChange}
					counts={{
						receivedAllCount: recievedFiltered.length,
						receivedPendingCount: recievedFiltered.filter(
							(item) => item.offer_status === 'PRE',
						).length,
						receivedNegotiatingCount: recievedFiltered.filter(
							(item) => item.offer_status === 'PROCEEDING',
						).length,
						sentAllCount: sentFiltered.length,
						sentPendingCount: sentFiltered.filter((item) => item.offer_status === 'PRE')
							.length,
						sentNegotiatingCount: sentFiltered.filter(
							(item) => item.offer_status === 'PROCEEDING',
						).length,
						pastAllCount: pastFiltered.length,
					}}
				/>

				{currentItems.length > 0 ? (
					currentItems.map((item) => (
						<div key={item.id} className={styles.contractItem}>
							<OfferItem
								item={item}
								tabType={selectedTab}
								onHistoryClick={(history) => {
									setHistoryModalData(history)
									setIsHistoryModalOpen(true)
								}}
								onVisitRenew={renewIsVisited}
								onContractClick={handleOfferClick}
							/>
						</div>
					))
				) : (
					<div className={styles.noContractContainer}>
						<div className={styles.noContractTitle}>
							{EMPTY_STATE_CONFIG[selectedTab]?.title}
						</div>
						<div className={styles.noContractBody}>
							<Link to={auth?.user?.userType === 'tourPro' ? '/search' : '/search'}>
								<div>
									<div className={styles.findMember}>
										<div>
											<svg
												width="13"
												height="12"
												viewBox="0 0 13 12"
												fill="none"
												xmlns="http://www.w3.org/2000/svg">
												<path
													fillRule="evenodd"
													clipRule="evenodd"
													d="M5.625 1.1875C3.45038 1.1875 1.6875 2.95038 1.6875 5.125C1.6875 7.29962 3.45038 9.0625 5.625 9.0625C6.71243 9.0625 7.69621 8.62226 8.40923 7.90923C9.12226 7.19621 9.5625 6.21243 9.5625 5.125C9.5625 2.95038 7.79962 1.1875 5.625 1.1875ZM0.8125 5.125C0.8125 2.46713 2.96713 0.3125 5.625 0.3125C8.28287 0.3125 10.4375 2.46713 10.4375 5.125C10.4375 6.29623 10.0187 7.37028 9.32329 8.20457L12.0594 10.9406C12.2302 11.1115 12.2302 11.3885 12.0594 11.5594C11.8885 11.7302 11.6115 11.7302 11.4406 11.5594L8.70457 8.82329C7.87028 9.51865 6.79623 9.9375 5.625 9.9375C2.96713 9.9375 0.8125 7.78287 0.8125 5.125Z"
													fill="white"
												/>
											</svg>
										</div>
										<div>
											{auth?.user?.userType === 'tourPro'
												? '캐디 찾고 제안 보내기'
												: '프로 찾고 제안 보내기'}
										</div>
									</div>
								</div>
							</Link>
						</div>
					</div>
				)}
			</div>

			{totalPages > 1 && (
				<div className={styles.pagination}>
					{/* 이전 페이지 그룹 버튼 */}
					{currentPageGroupStart !== 1 && ( // currentPageGroupStart가 1이 아닐 때만 보임
						<button className={styles.previousButton} onClick={goToPrevPageGroup}>
							<svg
								width="10"
								height="10"
								viewBox="0 0 10 10"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<g transform="rotate(180 5 5)">
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M5.74686 4.69064C5.91771 4.8615 5.91771 5.1385 5.74686 5.30936L1.37186 9.68436C1.20101 9.85521 0.923995 9.85521 0.753141 9.68436C0.582286 9.5135 0.582286 9.2365 0.753141 9.06564L4.81878 5L0.753141 0.934359C0.582287 0.763505 0.582287 0.486495 0.753141 0.315641C0.923996 0.144786 1.20101 0.144786 1.37186 0.315641L5.74686 4.69064Z"
										fill="#A0A0A0"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M9.24686 4.69064C9.41771 4.8615 9.91771 5.1385 9.24686 5.30936L4.87186 9.68436C4.70101 9.85521 4.424 9.85521 4.25314 9.68436C4.08229 9.5135 4.08229 9.2365 4.25314 9.06564L8.31878 5L4.25314 0.934359C4.08229 0.763505 4.08229 0.486495 4.25314 0.315641C4.424 0.144787 4.70101 0.144787 4.87186 0.315641L9.24686 4.69064Z"
										fill="#A0A0A0"
									/>
								</g>
							</svg>
						</button>
					)}

					{pageNumbers.map((number) => (
						<button
							key={number}
							onClick={() => paginate(number)}
							className={currentPage === number ? styles.active : ''}>
							{number}
						</button>
					))}

					{/* 다음 페이지 그룹 버튼 */}
					{currentPageGroupStart + pageGroupSize - 1 < totalPages && ( // 마지막 페이지 그룹이 아닐 때만 보임
						<button className={styles.nextButton} onClick={goToNextPageGroup}>
							<svg
								width="10"
								height="10"
								viewBox="0 0 10 10"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M5.74686 4.69064C5.91771 4.8615 5.91771 5.1385 5.74686 5.30936L1.37186 9.68436C1.20101 9.85521 0.923995 9.85521 0.753141 9.68436C0.582286 9.5135 0.582286 9.2365 0.753141 9.06564L4.81878 5L0.753141 0.934359C0.582287 0.763505 0.582287 0.486495 0.753141 0.315641C0.923996 0.144786 1.20101 0.144786 1.37186 0.315641L5.74686 4.69064Z"
									fill="#A0A0A0"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M9.24686 4.69064C9.41771 4.8615 9.41771 5.1385 9.24686 5.30936L4.87186 9.68436C4.70101 9.85521 4.424 9.85521 4.25314 9.68436C4.08229 9.5135 4.08229 9.2365 4.25314 9.06564L8.31878 5L4.25314 0.934359C4.08229 0.763505 4.08229 0.486495 4.25314 0.315641C4.424 0.144787 4.70101 0.144787 4.87186 0.315641L9.24686 4.69064Z"
									fill="#A0A0A0"
								/>
							</svg>
						</button>
					)}
				</div>
			)}
		</div>
	)
}
